// src/services/parquesService.js
import apiClient from "./apiClient";

export const USE_MOCK_ADMIN_PARQUES = false; // activar/desactivar mocks

// BASE de API real
const BASE_ADMIN = "SigiProdMici/api/admin/parquesindustriales";
const BASE_ADMIN1 = "SigiProdMici/api/admin";

/* ============================================================
 *  SERVICIOS EXISTENTES — NO TOCAR
 * ============================================================ */

const getParquesIndustriales = async (cod) => {
  try {
    const response = await apiClient.get(
      `SigiProdMici/GetIntervencionParquesIndrustriales?id_intervencion=${cod}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en parques" };
  }
};

const getDetalleIntervencion = async (id_intervencion, id_padre) => {
  try {
    const response = await apiClient.get(
      `SigiProdMici/GetDetalleIntervencion?id_intervencion=${id_intervencion}&id_padre=${id_padre}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en detalle intervención" };
  }
};

const getIntervencionParamDetalle = async (
  id_intervencion,
  id_padre,
  id_capa
) => {
  try {
    let url = `SigiProdMici/GetIntervencionParams?id_intervencion=${id_intervencion}`;

    if (id_padre) url += `&id_padre=${id_padre}`;
    if (id_capa) url += `&id_capa=${id_capa}`;

    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en detalle intervención" };
  }
};

const getParqueZonificacionIndustrial = async (
  id_intervencion,
  id_zonificacion_infra,
  id_zonificacion
) => {
  try {
    const url = `SigiProdMici/GetParqueZonificacionIndustrial?id_intervencion=${id_intervencion}&id_zonificacion_infra=${id_zonificacion_infra}&id_zonificacion=${id_zonificacion}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Error en detalle intervención" };
  }
};

/* ============================================================
 *  NUEVOS SERVICIOS — ADMIN PARQUES INDUSTRIALES
 * ============================================================ */

const listarParques = async (filtros = {}) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_listarParques(filtros);

  try {
    const response = await apiClient.get(`${BASE_ADMIN}`, { params: filtros });
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al listar parques industriales",
      }
    );
  }
};

const obtenerParque = async (id) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_obtenerParque(id);

  try {
    const response = await apiClient.get(`${BASE_ADMIN}/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al obtener parque industrial",
      }
    );
  }
};

const crearParque = async (payload) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_crearParque(payload);

  try {
    const response = await apiClient.post(`${BASE_ADMIN}`, payload);
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al crear parque industrial",
      }
    );
  }
};

const actualizarParque = async (id, payload) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_actualizarParque(id, payload);

  try {
    const response = await apiClient.put(`${BASE_ADMIN}/${id}`, payload);
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al actualizar parque industrial",
      }
    );
  }
};

const eliminarParque = async (id) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_eliminarParque(id);

  try {
    const response = await apiClient.delete(`${BASE_ADMIN}/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al eliminar parque industrial",
      }
    );
  }
};

/* ============================================================
 *  IMÁGENES — ADMIN (multi-upload + delete lista)
 * ============================================================ */

const listarImagenesParque = async (id) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_listarImagenes(id);

  try {
    const response = await apiClient.get(`${BASE_ADMIN}/${id}/imagenes`);
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al listar imágenes",
      }
    );
  }
};

// Multi-upload (usa FormData con varios files)
const subirImagenesParque = async (id, formData) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_subirImagenes(id, formData);

  try {
    const response = await apiClient.post(
      `${BASE_ADMIN}/${id}/imagenes`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al subir imágenes",
      }
    );
  }
};

// Eliminar varias imágenes de golpe (recibe array de IDs)
const eliminarImagenesParque = async (id, ids) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_eliminarImagenes(id, ids);

  try {
    const response = await apiClient.post(
      `${BASE_ADMIN}/${id}/imagenes/eliminar`,
      ids
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al eliminar imágenes",
      }
    );
  }
};

/* ============================================================
 *  (Opcional) endpoints singulares — por si luego los usas
 * ============================================================ */

const subirImagenParque = async (id, file, extraData = {}) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_subirImagen(id, file);

  try {
    const formData = new FormData();
    formData.append("file", file);

    Object.entries(extraData).forEach(([key, value]) => {
      if (value != null) formData.append(key, value);
    });

    const response = await apiClient.post(
      `${BASE_ADMIN}/${id}/imagenes`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al subir imagen",
      }
    );
  }
};

const eliminarImagenParque = async (id, idArchivo) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_eliminarImagen(id, idArchivo);

  try {
    const response = await apiClient.delete(
      `${BASE_ADMIN}/${id}/imagenes/${idArchivo}`
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Error al eliminar imagen",
      }
    );
  }
};

/* ================= ZONIFICACIÓN — ADMIN ================= */

const listarZonificacionesParque = async (idIntervencion) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_listarZonificaciones(idIntervencion);

  const resp = await apiClient.get(
    `${BASE_ADMIN}/${idIntervencion}/zonificaciones`
  );
  return resp.data;
};

const crearZonificacionParque = async (idIntervencion, payload) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_crearZonificacion(idIntervencion, payload);

  const resp = await apiClient.post(
    `${BASE_ADMIN}/${idIntervencion}/zonificaciones`,
    payload
  );
  return resp.data;
};

const actualizarZonificacionParque = async (idIntervencion, payload) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_actualizarZonificacion(idIntervencion, payload);

  const resp = await apiClient.put(
    `${BASE_ADMIN}/${idIntervencion}/zonificaciones/${payload.idZonificacionInfra}`,
    payload
  );
  return resp.data;
};

const eliminarZonificacionParque = async (idIntervencion, idZonificacionInfra) => {
  if (USE_MOCK_ADMIN_PARQUES) return mock_eliminarZonificacion(idIntervencion, idZonificacionInfra);

  const resp = await apiClient.delete(
    `${BASE_ADMIN}/${idIntervencion}/zonificaciones/${idZonificacionInfra}`
  );
  return resp.data;
};

const getZonificacionInfraImagenes = async (idZonificacionInfra) => { 

  const resp = await apiClient.get(
    `${BASE_ADMIN1}/zonificacion/${idZonificacionInfra}/imagenes`
  );

  return resp.data;
};



/* ============================================================
 *  MOCKS — Para probar UI sin backend
 * ============================================================ */

function mock_listarParques() {
  return Promise.resolve([
    {
      idIntervencion: 404,
      codigo: "ID_I20250002",
      nombreProyecto: "ANCON",
      idModalidad: 1,
      idTipoIntervencion: 1,
      idFinanciamiento: 1,
      idEstadoIntervencion: 1,
      idUbigeo: 150101,
      parametros: {
        departamento: { valor: "LIMA" },
        provincia: { valor: "CAÑETE" },
        distrito: { valor: "CHILCA" },
        hectareas: { valor: "234" },
        numeroLotesHabilitados: { valor: "348" },
        numeroLotesDisponibles: { valor: "68" },
      },
    },
    {
      idIntervencion: 405,
      codigo: "ID_I20250003",
      nombreProyecto: "ZED PAITA",
      parametros: {
        departamento: { valor: "PIURA" },
        provincia: { valor: "PAITA" },
        distrito: { valor: "PAITA" },
        hectareas: { valor: "940" },
        numeroLotesHabilitados: { valor: "92" },
        numeroLotesDisponibles: { valor: "39" },
      },
    },
  ]);
}

function mock_obtenerParque(id) {
  const idIntervencion = Number(id) || 404;

  return Promise.resolve({
    idIntervencion,
    codigo: "ID_I20250002",
    nombreProyecto: "Parque Industrial de Ancón",

    idModalidad: 1,
    idTipoIntervencion: 2,
    idFinanciamiento: 1,
    idEstadoIntervencion: 1,
    estadoNombre: "Vigente",

    idDepartamento: 15, // LIMA
    idProvincia: 2, // CAÑETE (ejemplo)
    idDistrito: 201, // CHILCA (ejemplo)
    idUbigeo: 150201,

    parametros: {
      departamento: {
        idParaInfraInt: 8284,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 38,
        tipoDato: "Departamento",
        valor: "LIMA",
      },
      provincia: {
        idParaInfraInt: 8285,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 39,
        tipoDato: "Provincia",
        valor: "CAÑETE",
      },
      distrito: {
        idParaInfraInt: 8286,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 40,
        tipoDato: "Distrito",
        valor: "CHILCA",
      },
      direccion: {
        idParaInfraInt: 8287,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 41,
        tipoDato: "Dirección",
        valor: "CHILCA",
      },
      hectareas: {
        idParaInfraInt: 8288,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 32,
        tipoDato: "N° de hectáreas (ha)",
        valor: "234",
      },
      hectareasHabilitar: {
        idParaInfraInt: 8289,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 54,
        tipoDato: "N° total de hectáreas habilitadas (ha)",
        valor: "224",
      },
      numeroEtapas: {
        idParaInfraInt: 8290,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 47,
        tipoDato: "N° total de etapas",
        valor: "3",
      },
      numeroEtapasHabilitadas: {
        idParaInfraInt: 8291,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 48,
        tipoDato: "N° total de etapas habilitadas",
        valor: "3",
      },
      numeroLotesHabilitados: {
        idParaInfraInt: 8292,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 51,
        tipoDato: "N° de lotes habilitados",
        valor: "348",
      },
      numeroLotesDisponibles: {
        idParaInfraInt: 8293,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 53,
        tipoDato: "N° total de lotes disponibles",
        valor: "68",
      },
      empresasInstalar: {
        idParaInfraInt: 8294,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 60,
        tipoDato: "Empresas a instalar",
        valor: "234",
      },
      puestosTrabajo: {
        idParaInfraInt: 8295,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 61,
        tipoDato: "Puestos de trabajo a generar",
        valor: "120000",
      },
      exportaciones: {
        idParaInfraInt: 8296,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 62,
        tipoDato: "Exportaciones",
        valor: "US$ 280MM",
      },
      inversionHabilitacion: {
        idParaInfraInt: 8297,
        idTipoInfraestructura: 2,
        idIntervencion,
        idPadre: 0,
        idInfraestructura: 63,
        tipoDato: "Inversión estimada en la habilitación",
        valor: "US$ 1 214.26MM",
      },
    },

    imagenes: [
      {
        idArchivo: 1,
        idIntervencion,
        nombreArchivo: "ancon1.jpg",
        urlArchivo: "/mock/parques/ancon1.jpg",
        tipo: "FOTO",
      },
      {
        idArchivo: 2,
        idIntervencion,
        nombreArchivo: "ancon2.jpg",
        urlArchivo: "/mock/parques/ancon2.jpg",
        tipo: "FOTO",
      },
    ],
  });
}

function mock_crearParque(payload) {
  // Simula que el backend devuelve un nuevo idIntervencion
  return Promise.resolve({
    success: true,
    idIntervencion: payload.idIntervencion || 999,
  });
}

function mock_actualizarParque(id, payload) {
  return Promise.resolve({ success: true, idIntervencion: id });
}

function mock_eliminarParque(id) {
  return Promise.resolve({ success: true });
}

function mock_listarImagenes(id) {
  return Promise.resolve([
    { idArchivo: 1, urlArchivo: "/mock/parques/ancon1.jpg" },
    { idArchivo: 2, urlArchivo: "/mock/parques/ancon2.jpg" },
  ]);
}

function mock_subirImagenes(id, formData) {
  return Promise.resolve({
    success: true,
    archivos: [
      { idArchivo: 101, urlArchivo: "/mock/parques/new1.jpg" },
      { idArchivo: 102, urlArchivo: "/mock/parques/new2.jpg" },
    ],
  });
}

function mock_subirImagen(id) {
  return Promise.resolve({ idArchivo: 99, urlArchivo: "/mock/parques/new.jpg" });
}

function mock_eliminarImagenes(id, ids) {
  return Promise.resolve({ success: true });
}

function mock_eliminarImagen(id, idArchivo) {
  return Promise.resolve({ success: true });
}


/* ============================================================
 *  MOCKS — ZONIFICACIONES
 * ============================================================ */

// idIntervencion => lista de zonas (cada una representa un registro en DAT_ZONIFICACION_INFRA
// + su detalle en DAT_PARA_INFRA_INT ya “explotado”)
function mock_listarZonificaciones(idIntervencion) {
  const id = Number(idIntervencion) || 405;

  return Promise.resolve([
    {
      idZonificacionInfra: 88,
      idIntervencion: id,
      mz: "G",
      etapa: "PRIMERA Y SEGUNDA ETAPA",
      area: "-",
      idZonificacion: 3,      // I3
      zonificacion: "I3",
      totalLotes: 28,
      lotesVendidos: 22,
      lotesReservados: 0,
      lotesDisponibles: 6,
    },
    {
      idZonificacionInfra: 89,
      idIntervencion: id,
      mz: "H",
      etapa: "PRIMERA ETAPA",
      area: "12 345",
      idZonificacion: 2,      // I2
      zonificacion: "I2",
      totalLotes: 15,
      lotesVendidos: 5,
      lotesReservados: 2,
      lotesDisponibles: 8,
    },
  ]);
}

function mock_crearZonificacion(idIntervencion, payload) {
  return Promise.resolve({
    idZonificacionInfra: 999, // id ficticio
    ...payload,
    idIntervencion: Number(idIntervencion),
  });
}

function mock_actualizarZonificacion(
  idIntervencion,
  idZonificacionInfra,
  payload
) {
  return Promise.resolve({
    idZonificacionInfra,
    idIntervencion: Number(idIntervencion),
    ...payload,
  });
}

function mock_eliminarZonificacion(idIntervencion, idZonificacionInfra) {
  return Promise.resolve({ success: true });
}


/* ============================================================
 * EXPORT
 * ============================================================ */

const parquesIndustriales = {
  // existentes
  getParquesIndustriales,
  getDetalleIntervencion,
  getIntervencionParamDetalle,
  getParqueZonificacionIndustrial,

  // admin CRUD
  listarParques,
  obtenerParque,
  crearParque,
  actualizarParque,
  eliminarParque,

  // imágenes (multi + single)
  listarImagenesParque,
  subirImagenesParque,
  eliminarImagenesParque,
  subirImagenParque,
  eliminarImagenParque,

  listarZonificacionesParque,
  crearZonificacionParque,
  actualizarZonificacionParque,
  eliminarZonificacionParque,

  getZonificacionInfraImagenes
};

export default parquesIndustriales;
